import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "h-100 flex-column d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-center justify-self-start" }, " Altere sua foto clicando na imagem abaixo ", -1)
const _hoisted_4 = { class: "h-100 d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarUploader = _resolveComponent("AvatarUploader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AvatarUploader, {
          avatar: _ctx.avatar,
          uploading: _ctx.uploading,
          onOnAvatarUploaded: _ctx.onAvatarUploaded,
          placeholder: _ctx.placeholder
        }, null, 8, ["avatar", "uploading", "onOnAvatarUploaded", "placeholder"])
      ]),
      _createVNode(_component_Button, {
        fullWidth: "",
        label: "Concluir",
        onOnClick: _ctx.updateProfileImage,
        loading: _ctx.submitting
      }, null, 8, ["onOnClick", "loading"])
    ])
  ]))
}